import { useCallback, useState } from 'react';
import i18next from 'i18next';
import { toast } from 'react-toastify';
import {
  MAX_ATTACHMENT_FILE_BYTES,
  MAX_IMAGE_FILE_BYTES,
} from 'shared-ui/lib/constants/image-upload-limits';
import { ImageType } from '../config/upload.config';
import { uploadFileToServer } from '../utils/upload-file-to-server';

interface Options {
  type: ImageType;
}

export const useUploadFile = ({ type }: Options) => {
  const [isImageLoading, setIsLoading] = useState(false);

  const uploadFile = useCallback(
    async (photo: null | string | File, id: string): Promise<boolean> => {
      if (photo instanceof File) {
        const isAttachmentUpload =
          type === 'vehicle-attachment' || type === 'service-event-attachment';
        const maxBytes = isAttachmentUpload
          ? MAX_ATTACHMENT_FILE_BYTES
          : MAX_IMAGE_FILE_BYTES;
        if (photo.size > maxBytes) {
          toast.error(
            isAttachmentUpload
              ? i18next.t('Upload:attachmentMaxSizeExceeded')
              : i18next.t('Upload:imageMaxSizeExceeded')
          );
          return false;
        }
        setIsLoading(true);
        try {
          await uploadFileToServer(photo, type, id);
          setIsLoading(false);
          return true;
        } catch (e) {
          if (e instanceof Error) toast.error(e.message);
          setIsLoading(false);
          return false;
        }
      }
      return true;
    },
    [setIsLoading, type]
  );

  return {
    isImageLoading,
    uploadFile,
  };
};
